import { InviteToFolderModal } from '../../Folder/InviteToFolderModal';

// Share a folder from My Resources. Delegates to the folder page's invite dialog so the invite
// flow is identical everywhere. Kept as a thin wrapper so existing call sites (collection + onClose)
// don't have to change.
export const ShareFolderModal = ({ collection, onClose }) => (
  <InviteToFolderModal
    collectionId={collection.id}
    folderName={collection.title}
    showModal={true}
    setShowModal={(open) => {
      if (!open) onClose();
    }}
  />
);
